module.exports = __webpack_public_path__ + "112851e33968eaab199095e503b8162e.MP3";